module.exports = __webpack_public_path__ + "static/fonts/iconfont.40c2a85.woff2";


//////////////////
// WEBPACK FOOTER
// ./static/csslib/iconfont/iconfont.woff2?t=1639703065688
// module id = +S15
// module chunks = 193